<template>
  <el-dialog class="dialog" width="700px" append-to-body :visible.sync="dialogVisible">
    <div class="title" style="margin-top:40px;">
      微信扫码关注官方公众号
    </div>
    <div class="title">
      安装APP或进入手机网页版，完成实名和开户
    </div>
    <div class="name-box">
      <img src="../../../assets/imgs/dp-public.jpg" style="margin-left:30px;" alt="name" class="name">
      <img src="../../../assets/imgs/home/public-desc.png" style="margin-right:30px;" alt="public" class="name">
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.$alert(`银联系统和银行系统升级中，预计2023年1月31日完成，在此期间暂停新用户开户，暂停交易，暂停资金转入（只允许资金提出），给您带来的不便请您原谅，我们将在银联和银行系统升级完成后第一时间短信通知到您。<br /><br />江苏数字产权交易有限公司<br />公告时间：2022年11月23日`, '公告', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true
      })
      // this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .title{
    text-align: center;
    color: white;
    font-size: 28px;
    font-weight: 700;
    padding: 10px 0;
  }
  .name{
    width: 300px;
    height: 300px;
    border-radius: 16px;
  }
  .name-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 400px;
  }
  .dialog{
    /deep/ .el-dialog{
      background: $sub-color;
      height: 600px;
      border-radius: 16px !important;
      overflow: hidden !important;
    }
  }
</style>